import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "../css/home-page.css";
import "../css/media-query.css";
import tvkBanner from "../assets/tvk-banner.jpg";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const dropdownRef = useRef(null);

  // ✅ Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <header className="header">

        {/* LEFT */}
        <div className="header-left">
          <Link to="/" className="nav-btn">Home</Link>
          <Link to="/about" className="nav-btn">About</Link>
          <Link to="/contact" className="nav-btn">Contact</Link>
        </div>

        {/* CENTER */}
        <div className="header-center">
          <img src={tvkBanner} alt="TVK Banner" className="banner" />
        </div>

        {/* RIGHT */}
        <div className="header-right">
          <Link to="/questionpage" className="nav-btn">அணுகவும்</Link>

          {/* ✅ DROPDOWN */}
          <div className="dropdown" ref={dropdownRef}>
            <button
              className="nav-btn"
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              மேலும் விவரங்கள் ▾
            </button>

            {dropdownOpen && (
              <div className="dropdown-menu">
                <Link 
                  to="/register"
                  onClick={() => setDropdownOpen(false)}
                >
                  கழகத்தில் இணைய
                </Link>

                <Link 
                  to="/login"
                  onClick={() => setDropdownOpen(false)}
                >
                  உறுப்பினர் உள்நுழைவு
                </Link>

                <Link 
                  to="/gallery"
                  onClick={() => setDropdownOpen(false)}
                >
                  Gallery
                </Link>
              </div>
            )}
          </div>

        </div>

        {/* MOBILE BAR */}
        <div className="glass-bar">
          <img src={tvkBanner} alt="TVK" className="mobile-banner" />

          <div
            className={`hamburger ${menuOpen ? "active" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

      </header>

      {/* SLIDE MENU */}
      <div className={`slide-menu ${menuOpen ? "open" : ""}`}>
        <Link to="/" onClick={()=>setMenuOpen(false)}>Home</Link>
        <Link to="/about" onClick={()=>setMenuOpen(false)}>About</Link>
        <Link to="/contact" onClick={()=>setMenuOpen(false)}>Contact</Link>
        <Link to="/questionpage" onClick={()=>setMenuOpen(false)}>அணுகவும்</Link>
        <Link to="/register" onClick={()=>setMenuOpen(false)}>கழகத்தில் இணைய</Link>
        <Link to="/login" onClick={()=>setMenuOpen(false)}>உறுப்பினர் உள்நுழைவு</Link>
      </div>

      {/* OVERLAY */}
      {menuOpen && (
        <div 
          className="overlay" 
          onClick={()=>setMenuOpen(false)}
        ></div>
      )}
    </>
  );
}

export default Navbar;
